import React from 'react';

export const FaceFearIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M29.9978 15.9989C29.9978 23.7303 25.3333 29.9978 15.9989 29.9978C6.66443 29.9978 2 23.7303 2 15.9989C2 15.3202 2.03594 14.6528 2.10783 14L15.9989 8L29.8899 14C29.9618 14.6528 29.9978 15.3202 29.9978 15.9989Z"
        fill="#FFB02E"
      />
      <path d="M29.89 14C29.143 7.21549 24.514 2 15.999 2C7.48389 2 2.85495 7.21549 2.10791 14H29.89Z" fill="#5092FF" />
      <path
        d="M10.5 18C12.9853 18 15 15.9853 15 13.5C15 11.0147 12.9853 9 10.5 9C8.01472 9 6 11.0147 6 13.5C6 15.9853 8.01472 18 10.5 18Z"
        fill="white"
      />
      <path
        d="M21.5 18C23.9853 18 26 15.9853 26 13.5C26 11.0147 23.9853 9 21.5 9C19.0147 9 17 11.0147 17 13.5C17 15.9853 19.0147 18 21.5 18Z"
        fill="white"
      />
      <path
        d="M8.95171 7.19985C9.49215 6.72518 9.82675 6.0733 10.0174 5.36941C10.0896 5.10287 10.3642 4.94532 10.6307 5.01751C10.8973 5.0897 11.0548 5.3643 10.9826 5.63084C10.7577 6.46133 10.3423 7.30946 9.61161 7.9512C8.87301 8.5999 7.85473 9.00012 6.5 9.00012C6.22386 9.00012 6 8.77627 6 8.50013C6 8.22398 6.22386 8.00013 6.5 8.00013C7.64527 8.00013 8.4192 7.66754 8.95171 7.19985Z"
        fill="#402A32"
      />
      <path
        d="M23.0483 7.19985C22.5079 6.72518 22.1733 6.0733 21.9826 5.36941C21.9104 5.10287 21.6358 4.94532 21.3693 5.01751C21.1027 5.0897 20.9452 5.3643 21.0174 5.63084C21.2423 6.46133 21.6577 7.30946 22.3884 7.9512C23.127 8.5999 24.1453 9.00012 25.5 9.00012C25.7761 9.00012 26 8.77627 26 8.50013C26 8.22398 25.7761 8.00013 25.5 8.00013C24.3547 8.00013 23.5808 7.66754 23.0483 7.19985Z"
        fill="#402A32"
      />
      <path
        d="M14 14.0001C14 15.1047 13.1046 16.0001 12 16.0001C10.8954 16.0001 10 15.1047 10 14.0001C10 12.8956 10.8954 12.0001 12 12.0001C13.1046 12.0001 14 12.8956 14 14.0001Z"
        fill="#402A32"
      />
      <path
        d="M22 14.0001C22 15.1047 21.1046 16.0001 20 16.0001C18.8954 16.0001 18 15.1047 18 14.0001C18 12.8956 18.8954 12.0001 20 12.0001C21.1046 12.0001 22 12.8956 22 14.0001Z"
        fill="#402A32"
      />
      <path
        d="M22.7179 24.0264C23.0288 25.0863 22.1033 26 20.9987 26C17.0451 26 14.6325 26 11.0008 26C9.8962 26 8.97119 25.0863 9.28207 24.0264C10.1341 21.1214 12.8193 19 16 19C19.1807 19 21.8659 21.1214 22.7179 24.0264Z"
        fill="#BB1D80"
      />
    </svg>
  );
};
